import { Component, OnInit } from '@angular/core';
import { SettingTabList } from '../setting.const';
import { SwitchboardChildTab, SwitchboardTabList } from './switchboard.const';
import { NavigationEnd, Router } from '@angular/router';
import { getCurrentTab } from './switchboard.const';

@Component({
  selector: 'settings-switchboard',
  templateUrl: './switchboard.component.html',
  styleUrls: ['./switchboard.component.css'],
})
export class SwitchboardComponent implements OnInit {
  public currentTab;
  public readonly switchboardTabList = SwitchboardTabList;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
  }

  onChangeTab(tabId: SwitchboardChildTab) {
    this.currentTab = tabId;
    this.router.navigate([tabId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/switchboard.component.ts